import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=3898e894&scoped=true"
import script from "./userAdd.vue?vue&type=script&lang=js"
export * from "./userAdd.vue?vue&type=script&lang=js"
import style0 from "./userAdd.vue?vue&type=style&index=0&id=3898e894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898e894",
  null
  
)

export default component.exports